export const isOwner = (shipper) => {
    return (shipper.role === "owner")
}

export const isEditor = (shipper) => {
    return (shipper.role === "editor")
}